import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../utils/api";
import MascotLogo from "./MascotLogo";

function CoachLeaderboard() {
  const [leaderboard, setLeaderboard] = useState([]);
  const [mascots, setMascots] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    Promise.all([
      axios.get(`${API_BASE_URL}/coach-leaderboard`),
      axios
        .get(`${API_BASE_URL}/coaches/mascots`)
        .catch(() => ({ data: { mascots: {} } })),
    ])
      .then(([leaderboardRes, mascotsRes]) => {
        if (cancelled) return;
        if (leaderboardRes.data.error) {
          setError(leaderboardRes.data.error);
        } else {
          setLeaderboard(leaderboardRes.data.leaderboard);
        }
        setMascots(mascotsRes.data?.mascots || {});
        setLoading(false);
      })
      .catch((err) => {
        if (cancelled) return;
        console.error("Error fetching coach leaderboard:", err);
        setError(err.message);
        setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const mascotFor = (coachName) => {
    const key = (coachName || "").toLowerCase();
    return mascots[key]?.image || "";
  };

  if (loading) {
    return <div className="coach-lb-state-text">Loading league leaders...</div>;
  }

  if (error) {
    return (
      <div className="coach-lb-error-text">
        Error loading leaderboard: {error}
      </div>
    );
  }

  return (
    <div className="coach-lb-page">
      <h2 className="coach-lb-title">League Leaders</h2>
      {leaderboard.length === 0 ? (
        <p className="coach-lb-state-text">No coach data available yet.</p>
      ) : (
        <div className="coach-lb-list">
          {leaderboard.map((entry, index) => {
            const points = Number(entry.total_points || 0);
            const maxPoints = Math.max(
              ...leaderboard.map((row) => Number(row.total_points || 0)),
              1,
            );
            const width = `${Math.max(8, Math.round((points / maxPoints) * 100))}%`;

            return (
              <article key={index} className="coach-lb-item">
                <div className="coach-lb-rank">{index + 1}</div>
                <MascotLogo
                  imageDataUrl={mascotFor(entry.coach)}
                  coachName={entry.coach}
                  size={80}
                  borderRadius="10px"
                />
                <div className="coach-lb-name-col">
                  <div className="coach-lb-td-coach">{entry.coach}</div>
                </div>
                <div className="coach-lb-score-col">
                  <div className="coach-lb-td-pts">+{points.toFixed(1)}</div>
                  <div className="coach-lb-track">
                    <div className="coach-lb-fill" style={{ width }} />
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default CoachLeaderboard;
